import { Confirmation, RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext, useState } from 'react';

import { useVisibilityMutation } from '../../generated/graphql';
import styles from './visibilityOffConfirmation.scss';
import CVAlert from '../CVAlert';
import Honeybadger from 'honeybadger-js';

export const VisibilityOffConfirmation: React.FC = () => {
  const [updateVisibility] = useVisibilityMutation();
  const { goBack } = useContext(RouterContext);
  const [erroring, setErroring] = useState(false);
  const SecondaryText = (
    <span className={styles.infoContainer}>
      <span>
        This will make your site harder to find. (Most guests will try to Google your site—remembering exact URLs is
        hard!)
      </span>
      <span>
        Nervous about privacy? Consider adding a guest password to your site! It doesn’t impact your search
        settings—giving you peace of mind and guests easy access.
      </span>
      <span className={styles.changesText}>Changes take up to 30 days</span>
    </span>
  );

  const onPrimary = async (): Promise<void> => {
    try {
      await updateVisibility({
        variables: {
          attributes: {
            searchable: false,
          },
        },
      });

      goBack();
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error updating visibility',
        context: {
          error,
        },
      });
      setErroring(true);
    }
  };

  return (
    <>
      <CVAlert erroring={erroring} onTimeout={() => setErroring(false)} />
      <Confirmation
        onPrimaryAction={onPrimary}
        onSecondaryAction={goBack}
        primaryText="Turn off searchability"
        secondaryText="Cancel"
        question="Are you sure?"
        info={SecondaryText}
      />
    </>
  );
};
